import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

const theBestKitchenPicksStyles: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-[#FBBF24]',
  COMMONS_APPBAR_TEXT: 'text-black',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-black',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-black',
  COMMONS_FOOTER_BG: 'bg-[#FBBF24]',
  COMMONS_FOOTER_TEXT: 'text-black',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-black',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#2743CE] [&>svg>path]:!stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: '',
  HOMEPAGE_HEADER_BG: 'bg-[#FFF8E7]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#8B85CF]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-black',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-black',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#2743CE] text-black hover:bg-[#2743CE] hover:text-white',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#8B85CF]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#6860C0]',
  HOMEPAGE_RANK_BANNER_BG: 'bg-[#FBBF24]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-black',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#FBBF24]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#6860C0]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#18297C] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#18297C] text-[#18297C] [&>svg>path]:stroke-[#18297C] [&>svg>g>path]:stroke-[#18297C] [&>svg>path]:fill-[#18297C] [&>svg>g>path]:fill-[#18297C]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#18297C]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#FBBF24]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#FFF8E7]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#6860C0]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#FFF8E7]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#FFF8E7] [&>g>.explore-icon-fill]:!fill-[#FFF8E7]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#FFF8E7] [&>.vector-top>path]:fill-[#FBBF24] [&>.vector-bottom>path]:fill-[#FBBF24]',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-gray-200',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#FB923C]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-black',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#FFF6D1]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-[#44403C]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#FB923C]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-black',
  LISTPAGE_BADGE_WINNER_DIVIDER: '',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#FB923C]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-black',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#6860C0]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#6860C0]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-white',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#5A75F9]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#18297C]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#18297C]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#5A75F9]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-white',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:fill-white',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#6860C0]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#18297C] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#18297C] text-[#18297C] [&>svg>path]:stroke-[#18297C] [&>svg>g>path]:stroke-[#18297C] [&>svg>path]:fill-[#18297C] [&>svg>g>path]:fill-[#18297C]',
  LISTPAGE_BUTTON_LINK: 'text-[#18297C]',
  LISTPAGE_ANCHOR_LINK: 'text-[#18297C]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#18297C]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#18297C]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#18297C]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#18297C] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#18297C] text-[#18297C] [&>svg>path]:stroke-[#18297C] [&>svg>g>path]:stroke-[#18297C]  [&>svg>path]:fill-[#18297C] [&>svg>g>path]:fill-[#18297C]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#18297C]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#18297C]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#18297C]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#18297C]',
  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-[#8B85CF]',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#18297C]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#FBBF24] [&>.vector-top>path]:fill-[#FFE08F] [&>.vector-bottom>path]:fill-[#FFE08F]',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-blue-100 [&>circle]:stroke-blue-100 [&>path]:fill-black',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-blue-50',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-black',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:text-white data-[focus]:bg-[#A3B3FF]',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'text-white bg-[#5A75F9]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#18297C]',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',

  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container',
}

export default theBestKitchenPicksStyles
